(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');
    module.directive('taskStatesFilter', [function () {
        var directive = {
            restrict: 'E',
            templateUrl: '/app/tasks/templates/task-states-filter.template.html',
            controller: 'TaskStatesFilterController',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                preSelectedStates: '=?', // preselected states - fe from messages
                paginationService: '=', // pagination service to hold data
                isToDo: '@' // type of tasks
            }
        };
        return directive;

    }]);

})();